import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { PrescriptionTemplateModal } from './PrescriptionTemplateModal.component'

const withUnmountHoc = withUnmountTransition(PrescriptionTemplateModal)
export { withUnmountHoc as PrescriptionTemplateModal }
